import { List } from 'immutable';
import { EmailSubscriptionDisplayType } from '../DisplayTypes';
import { makeOperator } from './Operator';
export default makeOperator({
  name: 'EmailSubscriptionOptOut',
  values: [{
    name: 'value',
    defaultValue: List(),
    isValid: value => List.isList(value) && !value.isEmpty()
  }, {
    name: 'isInexclusive',
    defaultValue: true
  }],
  displayType: EmailSubscriptionDisplayType
});